
export const resetAppStore = () => (dispatch) => {
    dispatch({
        type: "RESET_STATE_APP"
    })
}